<template>
  <mdb-container fluid>
    <section>
      <h2 class="mt-lg-5 mb-3 font-weight-bold"><strong>Typography</strong></h2>

      <!--Description-->
      <div class="description">
        <p>
          MDB Admin Dashboard includes simple and easily customized typography
          for headings, body text, lists, and more. For even more control, check
          out the
          <a href="https://mdbootstrap.com/utilities/"
            >textual utility classes</a
          >.
        </p>

        <p>
          The standard font for MDBootstrap is minimalist and elegant
          "<strong>Roboto</strong>" from Google.
        </p>

        <blockquote class="blockquote bq-primary">
          <p class="bq-title">About "Roboto"</p>
          <p>
            Roboto has a dual nature. It has a mechanical skeleton and the forms
            are largely geometric. At the same time, the font features friendly
            and open curves. While some grotesques distort their letterforms to
            force a rigid rhythm, Roboto doesn’t compromise, allowing letters to
            be settled into their natural width. This makes for a more natural
            reading rhythm more commonly found in humanist and serif types.
          </p>
        </blockquote>
      </div>
    </section>

    <!--Section: Headings-->
    <section>
      <!--Grid row-->
      <div class="row">
        <!--Grid column-->
        <div class="col-lg-4 col-md-12">
          <h4 class="mt-4 mb-5 font-weight-bold dark-grey-text">
            <strong>Standard</strong>
          </h4>

          <h1>h1. heading</h1>

          <hr />

          <h2>h2. heading</h2>

          <hr />

          <h3>h3. heading</h3>

          <hr />

          <h4>h4. heading</h4>

          <hr />

          <h5>h5. heading</h5>

          <hr />

          <h6>h6. heading</h6>
        </div>
        <!--Grid column-->

        <!--Grid column-->
        <div class="col-lg-4 col-md-6">
          <h4 class="mt-4 mb-5 font-weight-bold dark-grey-text">
            <strong>Classes</strong>
          </h4>

          <p class="h1">h1. Bootstrap heading</p>

          <hr />

          <p class="h2">h2. Bootstrap heading</p>

          <hr />

          <p class="h3">h3. Bootstrap heading</p>

          <hr />

          <p class="h4">h4. Bootstrap heading</p>

          <hr />

          <p class="h5">h5. Bootstrap heading</p>

          <hr />

          <p class="h6">h6. Bootstrap heading</p>
        </div>
        <!--Grid column-->

        <!--Grid column-->
        <div class="col-lg-4 col-md-6">
          <h4 class="mt-4 mb-5 font-weight-bold dark-grey-text">
            <strong>Responsive</strong>
          </h4>

          <h1 class="h1-responsive">h1. heading</h1>

          <hr />

          <h2 class="h2-responsive">h2. heading</h2>

          <hr />

          <h3 class="h3-responsive">h3. heading</h3>

          <hr />

          <h4 class="h4-responsive">h4. heading</h4>

          <hr />

          <h5 class="h5-responsive">h5. heading</h5>
        </div>
        <!--Grid column-->
      </div>
      <!--Grid row-->
    </section>
    <!--Section: Headings-->

    <hr class="my-5" />

    <!--Section: Customize-->
    <section>
      <h3>
        <strong>Fancy display heading</strong>
        <small class="text-muted">With faded secondary text</small>
      </h3>
    </section>
    <!--Section: Customize-->

    <hr class="my-5" />

    <!--Section: Display headings-->
    <section>
      <h1 class="display-1">Display 1</h1>

      <hr />

      <h1 class="display-2">Display 2</h1>

      <hr />

      <h1 class="display-3">Display 3</h1>

      <hr />

      <h1 class="display-4">Display 4</h1>
    </section>
    <!--Section: Display headings-->

    <hr class="my-5" />

    <!--Section: Lead-->
    <section>
      <h5>
        <u>Lead</u>
      </h5>
      <p class="lead">
        Vivamus sagittis lacus vel augue laoreet rutrum faucibus dolor auctor.
        Duis mollis, est non commodo luctus.
      </p>

      <br />
      <h5>
        <u>Regular paragraph</u>
      </h5>
      <p>
        Lorem ipsum dolor sit amet, consectetur adipisicing elit. Facilis
        tenetur sit voluptatem molestias ad neque veritatis! Alias natus, nobis
        laudantium, veritatis, atque illum ipsam nisi voluptas nesciunt harum
        laborum perspiciatis!
      </p>
    </section>
    <!--Section: Lead-->

    <hr class="my-5" />

    <!--Section: Inline text elements-->
    <section>
      <p>You can use the mark tag to <mark>highlight</mark> text.</p>
      <p>
        <del>This line of text is meant to be treated as deleted text.</del>
      </p>
      <p>
        <s>This line of text is meant to be treated as no longer accurate.</s>
      </p>
      <p>
        <ins
          >This line of text is meant to be treated as an addition to the
          document.</ins
        >
      </p>
      <p>
        <u>This line of text will render as underlined</u>
      </p>
      <p>
        <small>This line of text is meant to be treated as fine print.</small>
      </p>
      <p><strong>This line rendered as bold text.</strong></p>
      <p><em>This line rendered as italicized text.</em></p>
    </section>
    <!--Section: Inline text elements-->

    <hr class="my-5" />

    <!--Section: Text notifications-->
    <section>
      <blockquote class="blockquote bq-primary mb-5">
        <p class="bq-title">Info notification</p>
        <p>
          Lorem ipsum dolor sit amet, consectetur adipisicing elit. Maiores
          quibusdam dignissimos itaque harum illo! Quidem, corporis at quae
          tempore nisi impedit cupiditate perferendis nesciunt, ex dolores
          doloremque! Sit, rem, in?
        </p>
      </blockquote>

      <blockquote class="blockquote bq-warning mb-5">
        <p class="bq-title">Warning notification</p>
        <p>
          Lorem ipsum dolor sit amet, consectetur adipisicing elit. Maiores
          quibusdam dignissimos itaque harum illo! Quidem, corporis at quae
          tempore nisi impedit cupiditate perferendis nesciunt, ex dolores
          doloremque! Sit, rem, in?
        </p>
      </blockquote>

      <blockquote class="blockquote bq-success mb-5">
        <p class="bq-title">Success notification</p>
        <p>
          Lorem ipsum dolor sit amet, consectetur adipisicing elit. Maiores
          quibusdam dignissimos itaque harum illo! Quidem, corporis at quae
          tempore nisi impedit cupiditate perferendis nesciunt, ex dolores
          doloremque! Sit, rem, in?
        </p>
      </blockquote>

      <blockquote class="blockquote bq-danger mb-5">
        <p class="bq-title">Danger notification</p>
        <p>
          Lorem ipsum dolor sit amet, consectetur adipisicing elit. Maiores
          quibusdam dignissimos itaque harum illo! Quidem, corporis at quae
          tempore nisi impedit cupiditate perferendis nesciunt, ex dolores
          doloremque! Sit, rem, in?
        </p>
      </blockquote>
    </section>
    <!--Section: Text notifications-->

    <hr class="my-5" />

    <!--Section: Text color-->
    <section>
      <p class="red-text">
        Lorem ipsum dolor sit amet, consectetur adipisicing elit.
      </p>
      <p class="pink-text">
        Impedit architecto, totam hic sunt eum odio, deleniti.
      </p>
      <p class="purple-text">
        Similique ex, expedita minus assumenda a magni beatae dolorum itaque.
      </p>
      <p class="deep-purple-text">
        Veritatis eum libero nam, adipisci, necessitatibus eos.
      </p>
      <p class="indigo-text">
        Sapiente, ea. Molestias sunt nihil saepe numquam quas perferendis.
      </p>
      <p class="blue-text">
        Sapiente sit, possimus maiores, quo alias corporis cum eum nesciunt.
      </p>
      <p class="light-blue-text">
        Corrupti adipisci, praesentium iusto eos, iure debitis modi.
      </p>
      <p class="cyan-text">
        Odio autem veritatis aliquam consequuntur ea voluptatibus.
      </p>
      <p class="teal-text">
        Similique, adipisci ea, sequi magnam sit inventore.
      </p>
      <p class="green-text">
        Eos et vitae, odit deserunt dignissimos voluptas.
      </p>
      <p class="light-green-text">
        Fugit nihil numquam inventore accusantium tenetur ex est.
      </p>
      <p class="lime-text">
        Sed odit inventore illum excepturi officia, reiciendis numquam modi.
      </p>
      <p class="yellow-text">
        At odio animi distinctio, aut enim tempora nobis error odit mollitia.
      </p>
      <p class="amber-text">
        Quo at accusamus vel earum hic, inventore non, minima sint.
      </p>
      <p class="orange-text">
        Iusto odit eos distinctio temporibus voluptates ad, illo repellat.
      </p>
      <p class="deep-orange-text">
        Quas fugit fuga assumenda nihil esse et culpa reiciendis voluptatum.
      </p>
      <p class="brown-text">
        Excepturi iusto amet sunt illo ad debitis quibusdam eius, consequatur.
      </p>
      <p class="grey-text">
        Non sint nulla incidunt, odit repellat tempore, veniam ratione fugit.
      </p>
      <p class="blue-grey-text">
        Eius, provident. Quo similique, repellat atque voluptas explicabo odio.
      </p>
      <p class="white-text mdb-color">
        In consequuntur error, non consequatur expedita maxime dolorum.
      </p>
    </section>
    <!--Section: Text color-->

    <!--Section: Docs link-->
    <section>
      <!--Panel-->
      <div class="card text-center">
        <h3 class="card-header primary-color white-text">Full documentation</h3>
        <div class="card-body">
          <p class="card-text">
            Read the full documentation for these components.
          </p>
          <a
            href="https://mdbootstrap.com/docs/vue/content/typography/"
            target="_blank"
            class="btn btn-primary"
            >Learn more</a
          >
        </div>
      </div>
      <!--/.Panel-->
    </section>
    <!--Section: Docs link-->
  </mdb-container>
</template>

<script>
import { mdbContainer } from "mdbvue";

export default {
  name: "Typo",
  components: {
    mdbContainer,
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped></style>
